/**
 * The counted words this feature prints, in one place.
 *
 * A layer's shape count shows up on the layers panel, in both sharing screens
 * and on a phone card, and "1 shapes" is the kind of thing that only one of
 * the four gets fixed when each writes its own — so they all read this.
 */

/** `1 shape` · `4 shapes`. */
export const shapeWords = (count: number): string =>
  `${count} ${count === 1 ? 'shape' : 'shapes'}`

/** `1 layer` · `3 layers`. */
export const layerWords = (count: number): string =>
  `${count} ${count === 1 ? 'layer' : 'layers'}`
